import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { stepForm, onlyNumbersMixin, onlyLettersMixin } from "~/mixins";
import { required, email, maxLength, numeric, minLength } from "vuelidate/lib/validators";
import { onlyLetters, onlyEmail, charactersSpecial, noSpecialChars } from "~/validators";
import loader from "../modals/loader";

export default {
  mixins: [stepForm, onlyNumbersMixin, onlyLettersMixin],
  components: {
    loader: loader
  },
  data: function data() {
    var user = this.$store.state.affiliations.form.virtual.user;

    return {
      dataLegal: user.usingLegalRepresentativeData,
      userName: user.fullname,
      userEmail: user.email,
      userPhone: user.phone,
      sending: false
    };
  },
  validations: function validations() {
    return {
      userName: {
        required: required,
        charactersSpecial: charactersSpecial("userName"),
        onlyLetters: onlyLetters("userName")
      },
      userEmail: {
        required: required,
        // email,
        noSpecialChars: noSpecialChars('noSpecialChars'),
        emailValidate: onlyEmail('emailValidate')
      },
      userPhone: { required: required, numeric: numeric, minLength: minLength(7) }
    };
  },

  computed: {
    userNameErrorMessages: function userNameErrorMessages() {
      var errors = [];
      if (!this.$v.userName.$dirty) return errors;
      !this.$v.userName.required && errors.push("Campo obligatorio"), !this.$v.userName.charactersSpecial && errors.push("Caracter inválido"), !this.$v.userName.onlyLetters && errors.push("Ingrese sólo letras");
      return errors;
    },
    userEmailErrorMessages: function userEmailErrorMessages() {
      var errors = [];
      if (!this.$v.userEmail.$dirty) return errors;
      !this.$v.userEmail.required && errors.push("Campo obligatorio"), !this.$v.userEmail.noSpecialChars && errors.push('No puede ingresar caracteres espciales'), !this.$v.userEmail.emailValidate && errors.push("Ingresa un email válido");
      return errors;
    },
    userPhoneErrorMessages: function userPhoneErrorMessages() {
      var errors = [];
      if (!this.$v.userPhone.$dirty) return errors;
      !this.$v.userPhone.required && errors.push("Campo obligatorio"), !this.$v.userPhone.numeric && errors.push("Ingresa sólo números"), !this.$v.userPhone.minLength && errors.push("Ingresar como mínimo 9 números");
      return errors;
    }
  },
  methods: {
    onSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var results, messagePhone, timestamp, _ref2, existeCorreo, responseServer, _email, serverIp, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                this.loading = true;
                this.$refs.loaderModal.showLoader();
                _context.prev = 2;
                _context.next = 5;
                return _Promise.all([this.$store.dispatch("affiliations/form/postVerifiedPhone1", {
                  phone: this.userPhone
                })]);

              case 5:
                results = _context.sent;
                messagePhone = '';


                if (!results[0].code) messagePhone = "Tel\xE9fono de Usuario: " + results[0].message + "\n";

                if (!messagePhone) {
                  _context.next = 14;
                  break;
                }

                this.$swal('Aviso', messagePhone, 'warning');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                _context.next = 51;
                break;

              case 14:

                // servicio para verificar correo
                timestamp = Date.now();
                _context.next = 17;
                return this.$store.dispatch("affiliations/form/getVerifiedEmail", {
                  transaccionId: timestamp,
                  correo: this.userEmail
                });

              case 17:
                _ref2 = _context.sent;
                existeCorreo = _ref2.existeCorreo;
                responseServer = _ref2.responseServer;
                _email = _ref2.email;
                serverIp = _ref2.serverIp;

                if (!(responseServer === 'Error')) {
                  _context.next = 28;
                  break;
                }

                this.$swal('Error', 'Error en el servicio. Vuelva a intentarlo mas tarde.', 'error');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();
                _context.next = 51;
                break;

              case 28:
                if (!existeCorreo) {
                  _context.next = 48;
                  break;
                }

                this.$v.$touch();

                if (!this.$v.$invalid) {
                  _context.next = 32;
                  break;
                }

                return _context.abrupt("return");

              case 32:

                this.sending = true;

                data = {
                  fullname: this.userName,
                  email: this.userEmail,
                  phone: this.userPhone
                };
                _context.prev = 34;

                this.$store.commit("affiliations/form/setAdministrativePlataform", data);
                _context.next = 38;
                return this.$store.dispatch("affiliations/form/saveStepsAdministrativePlatform", {
                  usingLegalRepresentativeData: this.dataLegal,
                  firstlastName: this.userName,
                  email: this.userEmail,
                  cellPhone: this.userPhone
                });

              case 38:
                _context.next = 43;
                break;

              case 40:
                _context.prev = 40;
                _context.t0 = _context["catch"](34);

                this.$controlMessage(_context.t0);

              case 43:
                this.sending = false;
                this.errorMessage = null;
                this.$refs.loaderModal.closeLoader();
                _context.next = 51;
                break;

              case 48:
                this.$swal('Aviso', "No existe el correo " + this.email + ", ingresar uno correcto.", 'warning');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();

              case 51:
                _context.next = 58;
                break;

              case 53:
                _context.prev = 53;
                _context.t1 = _context["catch"](2);

                this.$swal('Aviso', "El correo ingresado tiene formato incorrecto.", 'warning');
                this.sending = false;
                this.$refs.loaderModal.closeLoader();

              case 58:
                this.loading = false;
                this.$refs.loaderModal.closeLoader();

              case 60:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 53], [34, 40]]);
      }));

      function onSubmit() {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }(),
    loadLegalRepresentativeData: function loadLegalRepresentativeData() {
      var response = this.$store.state["affiliations"].form.legalRepresentativeData;
      if (this.dataLegal == true) {
        this.userName = (response.firstName + " " + response.paternalName + " " + response.maternalName).trim();
        this.userPhone = response.cellPhone;
        this.userEmail = response.email;
      } else {
        this.userName = "";
        this.userPhone = "";
        this.userEmail = "";
        this.$v.$reset();
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/register-plataform.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/register-plataform.vue
// module chunks = 0 1 2 3